import React from 'react'
import { CircleHelp } from 'lucide-react'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'

/** 筛选旁的 Redis key 圆圈问号提示 */
const RedisKeyHint = ({
  keys,
  intersect = true,
}: {
  keys: Array<string | null | undefined>
  intersect?: boolean
}) => {
  const list = keys.filter((k): k is string => Boolean(k && k.trim()))
  if (list.length === 0) {
    return null
  }

  return (
    <HoverCard openDelay={120} closeDelay={80}>
      <HoverCardTrigger asChild>
        <button
          type="button"
          className="inline-flex shrink-0 text-muted-foreground transition-colors hover:text-foreground"
          aria-label="Redis key"
        >
          <CircleHelp className="h-4 w-4" />
        </button>
      </HoverCardTrigger>
      <HoverCardContent
        align="start"
        className="w-auto max-w-md p-3 text-xs leading-5 text-muted-foreground"
      >
        <div className="space-y-1.5">
          <div className="font-medium text-foreground">使用的 Redis key</div>
          {list.map((key, index) => (
            <code key={key} className="block break-all text-[11px]">
              {index === 0 || !intersect ? key : `∩ ${key}`}
            </code>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}

export default RedisKeyHint
